/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserModel } from '../entities/UserModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { companyModelSchema } from './companyModelSchema'
import { domainUserRoleStringSchema } from './domain/userRoleStringSchema'
import { z } from 'zod'

export const userModelSchema = z.object({
  company: z.lazy(() => companyModelSchema),
  email: z.string(),
  id: z.string(),
  name: z.string(),
  phone: z.number().int(),
  role: z.lazy(() => domainUserRoleStringSchema),
}) as unknown as ToZod<UserModel>